function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1Year(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500px",
    height: "500px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1964a1",
    d: "M 242.5,20.5 C 246.846,20.3343 251.179,20.501 255.5,21C 263.396,24.5629 271.062,28.5629 278.5,33C 286.374,33.0929 294.041,31.7595 301.5,29C 309.155,27.3705 316.155,28.7038 322.5,33C 328.554,39.0541 334.554,45.0541 340.5,51C 348.757,52.24 357.091,52.9067 365.5,53C 372.584,54.097 378.084,57.597 382,63.5C 384.607,68.3797 386.94,73.3797 389,78.5C 390.793,81.2953 392.96,83.7953 395.5,86C 402.332,88.7925 409.332,91.1259 416.5,93C 423.554,96.3894 428.054,101.889 430,109.5C 430.838,117.043 432.504,124.376 435,131.5C 440.837,137.174 447.337,142.008 454.5,146C 459.332,150.663 461.999,156.33 462.5,163C 460.978,171.451 460.478,179.951 461,188.5C 465.615,195.45 470.615,202.116 476,208.5C 477.968,211.737 479.135,215.237 479.5,219C 476.566,229.137 473.232,239.137 469.5,249C 471.343,256.856 474.176,264.356 478,271.5C 480.246,278.116 479.579,284.45 476,290.5C 470.615,296.884 465.615,303.55 461,310.5C 461.464,320.49 461.797,330.49 462,340.5C 460.861,344.112 459.194,347.446 457,350.5C 451.776,354.723 446.276,358.556 440.5,362C 438,363.833 435.833,366 434,368.5C 431.809,374.974 430.476,381.64 430,388.5C 428.751,395.842 424.917,401.342 418.5,405C 410.758,407.469 403.092,410.136 395.5,413C 394,414.5 392.5,416 391,417.5C 387.588,424.658 383.922,431.658 380,438.5C 376.323,442.423 371.823,444.923 366.5,446C 357.758,446.089 349.091,446.756 340.5,448C 334.221,454.279 327.887,460.613 321.5,467C 314.903,470.378 307.903,471.378 300.5,470C 293.416,467.06 286.083,465.726 278.5,466C 272.669,469.081 267.002,472.415 261.5,476C 254.298,480.099 246.964,480.432 239.5,477C 233.123,472.811 226.456,469.145 219.5,466C 211.907,465.635 204.573,466.969 197.5,470C 190.424,471.356 183.757,470.356 177.5,467C 171.801,461.635 166.467,455.969 161.5,450C 160.167,449.333 158.833,448.667 157.5,448C 148.884,446.827 140.217,446.161 131.5,446C 126.62,444.645 122.453,442.145 119,438.5C 115.078,431.658 111.412,424.658 108,417.5C 106.5,416 105,414.5 103.5,413C 94.9936,410.458 86.6602,407.458 78.5,404C 73.7047,400.245 70.538,395.412 69,389.5C 68.6328,382.294 67.2995,375.294 65,368.5C 59.0123,362.252 52.179,357.085 44.5,353C 39.2344,347.968 36.5677,341.801 36.5,334.5C 37.806,326.534 38.306,318.534 38,310.5C 34.0975,303.928 29.4309,297.928 24,292.5C 21.5948,288.118 20.0948,283.451 19.5,278.5C 22.6759,268.64 26.0093,258.807 29.5,249C 27.091,241.347 24.2577,233.847 21,226.5C 18.3553,218.761 19.6887,211.761 25,205.5C 30.1,200.403 34.4333,194.736 38,188.5C 37.776,178.159 37.4427,167.826 37,157.5C 38.6291,153.069 41.1291,149.236 44.5,146C 51.6627,142.008 58.1627,137.174 64,131.5C 66.8122,124.441 68.4788,117.108 69,109.5C 71.3407,101.159 76.5074,95.3262 84.5,92C 90.8946,90.2018 97.2279,88.2018 103.5,86C 105,84.5 106.5,83 108,81.5C 111.412,74.3423 115.078,67.3423 119,60.5C 121.892,57.9426 125.059,55.776 128.5,54C 138.141,52.9367 147.808,51.9367 157.5,51C 158.833,50.3333 160.167,49.6667 161.5,49C 167.585,40.9129 174.918,34.2462 183.5,29C 192.866,27.8733 201.866,29.2066 210.5,33C 213.5,33.6667 216.5,33.6667 219.5,33C 227.548,29.3132 235.215,25.1466 242.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfefe",
    d: "M 244.5,30.5 C 249.412,30.0631 254.078,30.8964 258.5,33C 271.751,44.7132 286.417,46.7132 302.5,39C 308.018,37.7131 313.018,38.7131 317.5,42C 323.253,49.7554 330.253,56.0887 338.5,61C 346.757,62.24 355.091,62.9067 363.5,63C 368.012,63.5082 371.512,65.6749 374,69.5C 377.011,77.6935 381.178,85.1935 386.5,92C 393.528,96.5663 401.195,99.5663 409.5,101C 412.759,102.211 415.592,104.044 418,106.5C 420.454,116.556 423.12,126.556 426,136.5C 430.971,142.798 437.137,147.631 444.5,151C 447.372,153.537 449.872,156.37 452,159.5C 451.021,169.445 450.687,179.445 451,189.5C 452.059,192.618 453.392,195.618 455,198.5C 459.712,203.543 464.045,208.877 468,214.5C 468.923,216.034 469.423,217.701 469.5,219.5C 467.512,227.146 464.678,234.479 461,241.5C 460.333,246.5 460.333,251.5 461,256.5C 463.676,263.2 466.342,269.867 469,276.5C 469.667,278.5 469.667,280.5 469,282.5C 462.945,290.222 457.278,298.222 452,306.5C 451.107,309.433 450.607,312.433 450.5,315.5C 451.214,321.328 451.88,327.162 452.5,333C 452.418,336.235 451.918,339.402 451,342.5C 442.818,348.593 434.818,354.926 427,361.5C 425.392,364.382 424.059,367.382 423,370.5C 421.911,377.543 420.578,384.543 419,391.5C 417.127,393.709 414.96,395.542 412.5,397C 404.123,399.014 396.123,402.014 388.5,406C 381.952,413.584 376.785,422.084 373,431.5C 371.442,433.359 369.609,434.859 367.5,436C 357.445,436.728 347.445,437.728 337.5,439C 334.567,440.271 331.901,441.938 329.5,444C 324.459,450.708 318.459,456.375 311.5,461C 309.167,461.667 306.833,461.667 304.5,461C 298.553,459.129 292.553,457.462 286.5,456C 280.026,455.118 274.026,456.451 268.5,460C 262.94,464.73 256.606,467.897 249.5,469.5C 241.735,467.618 234.735,464.118 228.5,459C 223.099,456.306 217.432,455.306 211.5,456C 205.447,457.462 199.447,459.129 193.5,461C 191.167,461.667 188.833,461.667 186.5,461C 184.167,459.333 181.833,457.667 179.5,456C 167.352,438.769 150.685,431.769 129.5,435C 128,433.5 126.5,432 125,430.5C 121.904,421.801 117.404,413.968 111.5,407C 103.44,402.182 94.7732,398.849 85.5,397C 84.4495,395.615 83.1161,394.615 81.5,394C 78.6715,383.872 75.8382,373.706 73,363.5C 67.7012,356.873 61.2012,351.706 53.5,348C 51.6667,346.167 49.8333,344.333 48,342.5C 47.042,339.925 46.542,337.259 46.5,334.5C 47.1301,328.329 47.7967,322.163 48.5,316C 48.2986,309.392 46.132,303.558 42,298.5C 35.7531,293.269 31.5864,286.769 29.5,279C 31.2879,272.252 33.7879,265.752 37,259.5C 38.4561,253.903 38.7894,248.237 38,242.5C 34.591,235.021 31.7577,227.354 29.5,219.5C 29.7628,216.972 30.5961,214.639 32,212.5C 38.2383,206.346 43.2383,199.346 47,191.5C 47.8934,188.567 48.3934,185.567 48.5,182.5C 46.9019,174.559 46.4019,166.559 47,158.5C 52.2723,152.603 58.4389,147.77 65.5,144C 70.2525,140.586 73.4191,136.086 75,130.5C 76.4262,123.516 77.7595,116.516 79,109.5C 81.2917,105.212 84.7917,102.378 89.5,101C 96.3816,99.2618 103.048,96.9285 109.5,94C 112.372,91.4634 114.872,88.6301 117,85.5C 120.078,79.0087 123.412,72.6754 127,66.5C 128.255,65.7894 129.421,64.956 130.5,64C 138.757,62.76 147.091,62.0933 155.5,62C 159.928,61.3033 163.928,59.6366 167.5,57C 172.833,50.3333 178.833,44.3333 185.5,39C 193.457,38.424 201.124,39.7573 208.5,43C 213.5,43.6667 218.5,43.6667 223.5,43C 230.894,39.3107 237.894,35.1441 244.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f68a3",
    d: "M 233.5,60.5 C 234.5,60.5 235.5,60.5 236.5,60.5C 236.5,61.5 236.5,62.5 236.5,63.5C 235.5,63.5 234.5,63.5 233.5,63.5C 233.5,62.5 233.5,61.5 233.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#286ba5",
    d: "M 240.5,60.5 C 241.5,60.5 242.5,60.5 243.5,60.5C 243.5,61.5 243.5,62.5 243.5,63.5C 242.5,63.5 241.5,63.5 240.5,63.5C 240.5,62.5 240.5,61.5 240.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#296da6",
    d: "M 247.5,60.5 C 248.5,60.5 249.5,60.5 250.5,60.5C 249.754,64.31 248.754,64.31 247.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3575ab",
    d: "M 254.5,60.5 C 255.978,60.238 257.311,60.5713 258.5,61.5C 256.537,64.1939 255.203,63.8606 254.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c76ac",
    d: "M 262.5,60.5 C 263.5,60.5 264.5,60.5 265.5,60.5C 265.5,61.5 265.5,62.5 265.5,63.5C 262.433,63.8795 261.433,62.8795 262.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b67a2",
    d: "M 226.5,61.5 C 229.957,61.6672 230.29,62.6672 227.5,64.5C 226.614,63.675 226.281,62.675 226.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2a6da6",
    d: "M 269.5,61.5 C 270.5,61.5 271.5,61.5 272.5,61.5C 272.5,62.5 272.5,63.5 272.5,64.5C 271.5,64.5 270.5,64.5 269.5,64.5C 269.5,63.5 269.5,62.5 269.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3574aa",
    d: "M 218.5,62.5 C 219.978,62.238 221.311,62.5713 222.5,63.5C 220.537,66.1939 219.203,65.8606 218.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b6da7",
    d: "M 276.5,62.5 C 277.5,62.5 278.5,62.5 279.5,62.5C 279.5,63.5 279.5,64.5 279.5,65.5C 278.5,65.5 277.5,65.5 276.5,65.5C 276.5,64.5 276.5,63.5 276.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3673aa",
    d: "M 211.5,63.5 C 216.833,64.5 216.833,65.5 211.5,66.5C 211.5,65.5 211.5,64.5 211.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2169a4",
    d: "M 283.5,63.5 C 284.5,63.5 285.5,63.5 286.5,63.5C 286.5,64.5 286.5,65.5 286.5,66.5C 285.5,66.5 284.5,66.5 283.5,66.5C 283.5,65.5 283.5,64.5 283.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3472a9",
    d: "M 290.5,64.5 C 291.5,64.5 292.5,64.5 293.5,64.5C 292.5,69.8333 291.5,69.8333 290.5,64.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#467fb1",
    d: "M 205.5,64.5 C 208.861,65.2032 209.194,66.5365 206.5,68.5C 204.358,67.5629 204.024,66.2296 205.5,64.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1d68a3",
    d: "M 297.5,66.5 C 298.5,66.5 299.5,66.5 300.5,66.5C 300.5,67.5 300.5,68.5 300.5,69.5C 299.5,69.5 298.5,69.5 297.5,69.5C 297.5,68.5 297.5,67.5 297.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#487eb1",
    d: "M 198.5,66.5 C 201.861,67.2032 202.194,68.5365 199.5,70.5C 197.358,69.5629 197.024,68.2296 198.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e68a3",
    d: "M 304.5,68.5 C 305.5,68.5 306.5,68.5 307.5,68.5C 307.5,69.5 307.5,70.5 307.5,71.5C 306.5,71.5 305.5,71.5 304.5,71.5C 304.5,70.5 304.5,69.5 304.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#457cb0",
    d: "M 191.5,68.5 C 194.861,69.2032 195.194,70.5365 192.5,72.5C 190.358,71.5629 190.024,70.2296 191.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f71a9",
    d: "M 184.5,70.5 C 187.861,71.2032 188.194,72.5365 185.5,74.5C 184.571,73.3112 184.238,71.9778 184.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b77ad",
    d: "M 311.5,70.5 C 312.5,70.5 313.5,70.5 314.5,70.5C 314.778,72.3464 314.111,73.6798 312.5,74.5C 311.571,73.3112 311.238,71.9778 311.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#266ba5",
    d: "M 177.5,73.5 C 178.5,73.5 179.5,73.5 180.5,73.5C 180.5,74.5 180.5,75.5 180.5,76.5C 179.5,76.5 178.5,76.5 177.5,76.5C 177.5,75.5 177.5,74.5 177.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3271a9",
    d: "M 318.5,73.5 C 319.5,73.5 320.5,73.5 321.5,73.5C 321.5,74.5 321.5,75.5 321.5,76.5C 318.506,76.8543 317.506,75.8543 318.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#296ba5",
    d: "M 171.5,76.5 C 173.048,76.8212 173.715,77.8212 173.5,79.5C 170.752,79.5983 170.086,78.5983 171.5,76.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#296ca6",
    d: "M 324.5,76.5 C 325.5,76.5 326.5,76.5 327.5,76.5C 327.5,77.5 327.5,78.5 327.5,79.5C 326.5,79.5 325.5,79.5 324.5,79.5C 324.5,78.5 324.5,77.5 324.5,76.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f69a4",
    d: "M 164.5,79.5 C 165.5,79.5 166.5,79.5 167.5,79.5C 167.5,80.5 167.5,81.5 167.5,82.5C 166.5,82.5 165.5,82.5 164.5,82.5C 164.5,81.5 164.5,80.5 164.5,79.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2269a4",
    d: "M 331.5,79.5 C 332.5,79.5 333.5,79.5 334.5,79.5C 334.5,80.5 334.5,81.5 334.5,82.5C 333.5,82.5 332.5,82.5 331.5,82.5C 331.5,81.5 331.5,80.5 331.5,79.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3e7aae",
    d: "M 158.5,82.5 C 161.861,83.2032 162.194,84.5365 159.5,86.5C 157.358,85.5629 157.024,84.2296 158.5,82.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e67a3",
    d: "M 338.5,82.5 C 340.048,82.8212 340.715,83.8212 340.5,85.5C 337.752,85.5983 337.086,84.5983 338.5,82.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2369a4",
    d: "M 151.5,86.5 C 152.5,86.5 153.5,86.5 154.5,86.5C 154.5,87.5 154.5,88.5 154.5,89.5C 153.5,89.5 152.5,89.5 151.5,89.5C 151.5,88.5 151.5,87.5 151.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b76ac",
    d: "M 343.5,86.5 C 344.978,86.238 346.311,86.5713 347.5,87.5C 346.68,89.1112 345.346,89.7778 343.5,89.5C 343.5,88.5 343.5,87.5 343.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b67a3",
    d: "M 145.5,90.5 C 146.5,90.5 147.5,90.5 148.5,90.5C 147.754,94.31 146.754,94.31 145.5,90.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#427db0",
    d: "M 350.5,89.5 C 353.861,90.2032 354.194,91.5365 351.5,93.5C 349.358,92.5629 349.024,91.2296 350.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1a66a2",
    d: "M 139.5,94.5 C 140.5,94.5 141.5,94.5 142.5,94.5C 141.754,98.31 140.754,98.31 139.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#407caf",
    d: "M 356.5,93.5 C 359.861,94.2032 360.194,95.5365 357.5,97.5C 355.358,96.5629 355.024,95.2296 356.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b75ac",
    d: "M 134.5,98.5 C 135.995,98.4148 136.995,99.0815 137.5,100.5C 136.167,101.833 134.833,101.833 133.5,100.5C 133.863,99.8165 134.196,99.1499 134.5,98.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#256aa4",
    d: "M 361.5,98.5 C 362.5,98.5 363.5,98.5 364.5,98.5C 364.5,99.5 364.5,100.5 364.5,101.5C 363.5,101.5 362.5,101.5 361.5,101.5C 361.5,100.5 361.5,99.5 361.5,98.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3371a9",
    d: "M 367.5,102.5 C 368.5,102.5 369.5,102.5 370.5,102.5C 369.5,107.833 368.5,107.833 367.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b77ac",
    d: "M 128.5,102.5 C 130.912,102.694 131.912,104.027 131.5,106.5C 130.5,106.5 129.5,106.5 128.5,106.5C 128.5,105.167 128.5,103.833 128.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#226aa4",
    d: "M 123.5,107.5 C 125.048,107.821 125.715,108.821 125.5,110.5C 122.752,110.598 122.086,109.598 123.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3e77ac",
    d: "M 372.5,107.5 C 374.346,107.222 375.68,107.889 376.5,109.5C 375.311,110.429 373.978,110.762 372.5,110.5C 372.5,109.5 372.5,108.5 372.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e68a3",
    d: "M 117.5,112.5 C 118.5,112.5 119.5,112.5 120.5,112.5C 120.5,113.5 120.5,114.5 120.5,115.5C 119.5,115.5 118.5,115.5 117.5,115.5C 117.5,114.5 117.5,113.5 117.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2469a4",
    d: "M 378.5,112.5 C 379.5,112.5 380.5,112.5 381.5,112.5C 381.5,113.5 381.5,114.5 381.5,115.5C 380.5,115.5 379.5,115.5 378.5,115.5C 378.5,114.5 378.5,113.5 378.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#256ba5",
    d: "M 383.5,117.5 C 384.5,117.5 385.5,117.5 386.5,117.5C 386.5,118.5 386.5,119.5 386.5,120.5C 385.5,120.5 384.5,120.5 383.5,120.5C 383.5,119.5 383.5,118.5 383.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2268a3",
    d: "M 112.5,117.5 C 113.5,117.5 114.5,117.5 115.5,117.5C 115.5,118.5 115.5,119.5 115.5,120.5C 114.5,120.5 113.5,120.5 112.5,120.5C 112.5,119.5 112.5,118.5 112.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b75ac",
    d: "M 108.5,122.5 C 109.586,122.62 110.253,123.287 110.5,124.5C 109.696,126.957 108.696,126.957 107.5,124.5C 107.863,123.817 108.196,123.15 108.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#477eb1",
    d: "M 388.5,122.5 C 391.861,123.203 392.194,124.537 389.5,126.5C 387.358,125.563 387.024,124.23 388.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4279ae",
    d: "M 102.5,128.5 C 103.833,128.5 105.167,128.5 106.5,128.5C 106.5,129.5 106.5,130.5 106.5,131.5C 105.167,131.5 103.833,131.5 102.5,131.5C 102.5,130.5 102.5,129.5 102.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3271a9",
    d: "M 392.5,128.5 C 393.978,128.238 395.311,128.571 396.5,129.5C 394.537,132.194 393.203,131.861 392.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2d6ea7",
    d: "M 99.5,133.5 C 101.104,134.287 101.771,135.62 101.5,137.5C 100.5,137.5 99.5,137.5 98.5,137.5C 98.4326,136.041 98.7659,134.708 99.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3773aa",
    d: "M 397.5,133.5 C 398.5,133.5 399.5,133.5 400.5,133.5C 400.778,135.346 400.111,136.68 398.5,137.5C 397.571,136.311 397.238,134.978 397.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b6da6",
    d: "M 401.5,139.5 C 402.5,139.5 403.5,139.5 404.5,139.5C 404.5,140.5 404.5,141.5 404.5,142.5C 403.5,142.5 402.5,142.5 401.5,142.5C 401.5,141.5 401.5,140.5 401.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#467eb1",
    d: "M 94.5,139.5 C 97.8606,140.203 98.1939,141.537 95.5,143.5C 93.3576,142.563 93.0243,141.23 94.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0f619f",
    d: "M 259.5,141.5 C 268.5,141.5 277.5,141.5 286.5,141.5C 286.5,178.167 286.5,214.833 286.5,251.5C 274.259,248.927 261.925,246.76 249.5,245C 243.509,244.501 237.509,244.334 231.5,244.5C 231.5,213.5 231.5,182.5 231.5,151.5C 220.859,152.997 210.193,154.33 199.5,155.5C 199.5,153.5 199.5,151.5 199.5,149.5C 219.493,146.773 239.493,144.107 259.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f8bb8",
    d: "M 259.5,141.5 C 268.652,140.506 277.985,140.173 287.5,140.5C 287.5,177.833 287.5,215.167 287.5,252.5C 286.833,252.5 286.5,252.167 286.5,251.5C 286.5,214.833 286.5,178.167 286.5,141.5C 277.5,141.5 268.5,141.5 259.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b6da6",
    d: "M 405.5,145.5 C 406.5,145.5 407.5,145.5 408.5,145.5C 408.5,146.5 408.5,147.5 408.5,148.5C 407.5,148.5 406.5,148.5 405.5,148.5C 405.5,147.5 405.5,146.5 405.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3e7aae",
    d: "M 90.5,145.5 C 93.8606,146.203 94.1939,147.537 91.5,149.5C 89.3576,148.563 89.0243,147.23 90.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b76ac",
    d: "M 86.5,151.5 C 88.9118,151.694 89.9118,153.027 89.5,155.5C 88.5,155.5 87.5,155.5 86.5,155.5C 86.5,154.167 86.5,152.833 86.5,151.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2369a4",
    d: "M 409.5,151.5 C 410.5,151.5 411.5,151.5 412.5,151.5C 412.5,152.5 412.5,153.5 412.5,154.5C 411.5,154.5 410.5,154.5 409.5,154.5C 409.5,153.5 409.5,152.5 409.5,151.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#328edd",
    d: "M 138.5,154.5 C 141.14,159.085 142.806,164.085 143.5,169.5C 149.176,169.334 154.843,169.501 160.5,170C 155.761,173.031 151.428,176.531 147.5,180.5C 149.54,185.444 151.04,190.444 152,195.5C 147.667,192.167 143.333,188.833 139,185.5C 134.667,188.833 130.333,192.167 126,195.5C 126.96,190.444 128.46,185.444 130.5,180.5C 126.572,176.531 122.239,173.031 117.5,170C 123.157,169.501 128.824,169.334 134.5,169.5C 135.424,164.393 136.758,159.393 138.5,154.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#328edd",
    d: "M 359.5,154.5 C 362.14,159.085 363.806,164.085 364.5,169.5C 370.176,169.334 375.843,169.501 381.5,170C 376.761,173.031 372.428,176.531 368.5,180.5C 370.54,185.444 372.04,190.444 373,195.5C 368.667,192.167 364.333,188.833 360,185.5C 355.667,188.833 351.333,192.167 347,195.5C 347.96,190.444 349.46,185.444 351.5,180.5C 347.572,176.531 343.239,173.031 338.5,170C 344.157,169.501 349.824,169.334 355.5,169.5C 356.424,164.393 357.758,159.393 359.5,154.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2269a4",
    d: "M 82.5,158.5 C 83.5,158.5 84.5,158.5 85.5,158.5C 85.5,159.5 85.5,160.5 85.5,161.5C 84.5,161.5 83.5,161.5 82.5,161.5C 82.5,160.5 82.5,159.5 82.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4780b2",
    d: "M 413.5,157.5 C 416.861,158.203 417.194,159.537 414.5,161.5C 412.358,160.563 412.024,159.23 413.5,157.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#266ba5",
    d: "M 79.5,164.5 C 80.5,164.5 81.5,164.5 82.5,164.5C 82.5,165.5 82.5,166.5 82.5,167.5C 81.5,167.5 80.5,167.5 79.5,167.5C 79.5,166.5 79.5,165.5 79.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2269a4",
    d: "M 416.5,164.5 C 417.5,164.5 418.5,164.5 419.5,164.5C 419.5,165.5 419.5,166.5 419.5,167.5C 418.5,167.5 417.5,167.5 416.5,167.5C 416.5,166.5 416.5,165.5 416.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#266ba5",
    d: "M 76.5,171.5 C 77.5,171.5 78.5,171.5 79.5,171.5C 79.5,172.5 79.5,173.5 79.5,174.5C 78.5,174.5 77.5,174.5 76.5,174.5C 76.5,173.5 76.5,172.5 76.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e6fa7",
    d: "M 419.5,170.5 C 420.5,170.5 421.5,170.5 422.5,170.5C 421.5,175.833 420.5,175.833 419.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f77ad",
    d: "M 73.5,177.5 C 74.5,177.5 75.5,177.5 76.5,177.5C 76.7778,179.346 76.1112,180.68 74.5,181.5C 73.5713,180.311 73.238,178.978 73.5,177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b6da7",
    d: "M 422.5,177.5 C 423.5,177.5 424.5,177.5 425.5,177.5C 425.5,178.5 425.5,179.5 425.5,180.5C 424.5,180.5 423.5,180.5 422.5,180.5C 422.5,179.5 422.5,178.5 422.5,177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d77ad",
    d: "M 70.5,184.5 C 72.3464,184.222 73.6798,184.889 74.5,186.5C 73.3112,187.429 71.9778,187.762 70.5,187.5C 70.5,186.5 70.5,185.5 70.5,184.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#417caf",
    d: "M 425.5,183.5 C 428.861,184.203 429.194,185.537 426.5,187.5C 424.358,186.563 424.024,185.23 425.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2069a3",
    d: "M 68.5,191.5 C 69.5,191.5 70.5,191.5 71.5,191.5C 71.5,192.5 71.5,193.5 71.5,194.5C 70.5,194.5 69.5,194.5 68.5,194.5C 68.5,193.5 68.5,192.5 68.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#407baf",
    d: "M 427.5,190.5 C 430.861,191.203 431.194,192.537 428.5,194.5C 426.358,193.563 426.024,192.23 427.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3774ab",
    d: "M 429.5,197.5 C 432.861,198.203 433.194,199.537 430.5,201.5C 429.571,200.311 429.238,198.978 429.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e68a3",
    d: "M 66.5,198.5 C 67.5,198.5 68.5,198.5 69.5,198.5C 69.5,199.5 69.5,200.5 69.5,201.5C 68.5,201.5 67.5,201.5 66.5,201.5C 66.5,200.5 66.5,199.5 66.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3272a9",
    d: "M 64.5,205.5 C 65.9778,205.238 67.3112,205.571 68.5,206.5C 66.5365,209.194 65.2032,208.861 64.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#447db0",
    d: "M 431.5,204.5 C 434.861,205.203 435.194,206.537 432.5,208.5C 430.358,207.563 430.024,206.23 431.5,204.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#236aa4",
    d: "M 63.5,212.5 C 64.5,212.5 65.5,212.5 66.5,212.5C 66.5,213.5 66.5,214.5 66.5,215.5C 65.5,215.5 64.5,215.5 63.5,215.5C 63.5,214.5 63.5,213.5 63.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#276ca6",
    d: "M 433.5,211.5 C 435.97,212.36 436.137,213.694 434,215.5C 432.232,214.318 432.065,212.985 433.5,211.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#286ba5",
    d: "M 62.5,219.5 C 63.5,219.5 64.5,219.5 65.5,219.5C 65.5,220.5 65.5,221.5 65.5,222.5C 64.5,222.5 63.5,222.5 62.5,222.5C 62.5,221.5 62.5,220.5 62.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b77ac",
    d: "M 434.5,218.5 C 435.586,218.62 436.253,219.287 436.5,220.5C 435.696,222.957 434.696,222.957 433.5,220.5C 433.863,219.817 434.196,219.15 434.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#286ba5",
    d: "M 61.5,226.5 C 62.5,226.5 63.5,226.5 64.5,226.5C 64.5,227.5 64.5,228.5 64.5,229.5C 63.5,229.5 62.5,229.5 61.5,229.5C 61.5,228.5 61.5,227.5 61.5,226.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3070a8",
    d: "M 435.5,225.5 C 436.586,225.62 437.253,226.287 437.5,227.5C 436.696,229.957 435.696,229.957 434.5,227.5C 434.863,226.817 435.196,226.15 435.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2069a4",
    d: "M 435.5,233.5 C 436.5,233.5 437.5,233.5 438.5,233.5C 438.5,234.5 438.5,235.5 438.5,236.5C 437.5,236.5 436.5,236.5 435.5,236.5C 435.5,235.5 435.5,234.5 435.5,233.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2469a4",
    d: "M 60.5,233.5 C 61.5,233.5 62.5,233.5 63.5,233.5C 63.5,234.5 63.5,235.5 63.5,236.5C 62.5,236.5 61.5,236.5 60.5,236.5C 60.5,235.5 60.5,234.5 60.5,233.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#266ba5",
    d: "M 435.5,240.5 C 436.5,240.5 437.5,240.5 438.5,240.5C 438.5,241.5 438.5,242.5 438.5,243.5C 437.5,243.5 436.5,243.5 435.5,243.5C 435.5,242.5 435.5,241.5 435.5,240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d79ae",
    d: "M 60.5,240.5 C 63.8606,241.203 64.1939,242.537 61.5,244.5C 60.5713,243.311 60.238,241.978 60.5,240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2389db",
    d: "M 231.5,244.5 C 237.509,244.334 243.509,244.501 249.5,245C 261.925,246.76 274.259,248.927 286.5,251.5C 286.5,252.167 286.833,252.5 287.5,252.5C 290.616,253.075 293.783,253.409 297,253.5C 305.262,252.952 313.428,252.118 321.5,251C 317.622,256.589 313.622,262.089 309.5,267.5C 314.371,271.205 318.371,275.705 321.5,281C 318.79,282.747 315.79,283.747 312.5,284C 304.118,284.773 295.785,284.606 287.5,283.5C 287.167,283.5 286.833,283.5 286.5,283.5C 268.137,280.659 249.804,277.659 231.5,274.5C 230.209,274.263 229.209,274.596 228.5,275.5C 221.907,274.539 215.907,275.872 210.5,279.5C 206.675,269.92 206.508,260.254 210,250.5C 216.316,245.628 223.482,243.628 231.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d79ad",
    d: "M 435.5,247.5 C 436.833,247.5 438.167,247.5 439.5,247.5C 439.778,249.346 439.111,250.68 437.5,251.5C 435.889,250.68 435.222,249.346 435.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3473aa",
    d: "M 60.5,247.5 C 63.8606,248.203 64.1939,249.537 61.5,251.5C 60.5713,250.311 60.238,248.978 60.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7fbfd",
    d: "M 228.5,250.5 C 229.873,250.343 231.207,250.51 232.5,251C 229.878,254.405 228.545,258.239 228.5,262.5C 227.5,262.5 226.5,262.5 225.5,262.5C 225.66,260.801 225.494,259.134 225,257.5C 218.627,251.107 219.294,250.107 227,254.5C 227.791,253.255 228.291,251.922 228.5,250.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f9fd",
    d: "M 246.5,251.5 C 244.844,253.06 242.844,254.06 240.5,254.5C 241.919,255.451 243.585,255.784 245.5,255.5C 245.5,256.5 245.5,257.5 245.5,258.5C 243.833,258.5 242.167,258.5 240.5,258.5C 239.957,258.56 239.624,258.893 239.5,259.5C 241.743,260.474 244.076,260.808 246.5,260.5C 243.663,262.402 240.329,263.069 236.5,262.5C 236.5,258.5 236.5,254.5 236.5,250.5C 239.833,250.833 243.167,251.167 246.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#89c0ec",
    d: "M 246.5,251.5 C 247.404,252.209 247.737,253.209 247.5,254.5C 245.167,254.5 242.833,254.5 240.5,254.5C 242.844,254.06 244.844,253.06 246.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eff6fc",
    d: "M 254.5,252.5 C 256.117,253.038 257.784,253.371 259.5,253.5C 259.646,257.519 259.979,261.519 260.5,265.5C 257.737,265.204 255.237,264.204 253,262.5C 251.506,263.747 250.006,263.747 248.5,262.5C 250.511,259.139 252.511,255.806 254.5,252.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1966a2",
    d: "M 60.5,255.5 C 63.9571,255.667 64.2904,256.667 61.5,258.5C 60.6143,257.675 60.281,256.675 60.5,255.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3e77ad",
    d: "M 435.5,255.5 C 436.978,255.238 438.311,255.571 439.5,256.5C 438.68,258.111 437.346,258.778 435.5,258.5C 435.5,257.5 435.5,256.5 435.5,255.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1f7fc",
    d: "M 266.5,256.5 C 269.647,256.737 272.647,257.57 275.5,259C 276.554,260.388 276.72,261.888 276,263.5C 274.165,265.449 272.999,267.783 272.5,270.5C 270.343,269.152 269.01,267.152 268.5,264.5C 267.579,266.756 265.912,267.756 263.5,267.5C 264.2,263.763 265.2,260.096 266.5,256.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7bb8e9",
    d: "M 240.5,258.5 C 242.5,259.167 244.5,259.833 246.5,260.5C 244.076,260.808 241.743,260.474 239.5,259.5C 239.624,258.893 239.957,258.56 240.5,258.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#57a4e3",
    d: "M 255.5,256.5 C 256.782,257.708 256.782,259.042 255.5,260.5C 254.374,259.192 254.374,257.858 255.5,256.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f90dd",
    d: "M 269.5,259.5 C 270.643,259.908 271.643,260.575 272.5,261.5C 270.604,262.639 269.604,261.973 269.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b67a3",
    d: "M 60.5,262.5 C 61.5,262.5 62.5,262.5 63.5,262.5C 63.5,263.5 63.5,264.5 63.5,265.5C 62.5,265.5 61.5,265.5 60.5,265.5C 60.5,264.5 60.5,263.5 60.5,262.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1d67a3",
    d: "M 435.5,262.5 C 436.5,262.5 437.5,262.5 438.5,262.5C 438.5,263.5 438.5,264.5 438.5,265.5C 437.5,265.5 436.5,265.5 435.5,265.5C 435.5,264.5 435.5,263.5 435.5,262.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2068a3",
    d: "M 61.5,269.5 C 65.31,270.754 65.31,271.754 61.5,272.5C 61.5,271.5 61.5,270.5 61.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#296ca6",
    d: "M 434.5,269.5 C 435.5,269.5 436.5,269.5 437.5,269.5C 437.5,270.5 437.5,271.5 437.5,272.5C 436.5,272.5 435.5,272.5 434.5,272.5C 434.5,271.5 434.5,270.5 434.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#92b8d4",
    d: "M 228.5,275.5 C 229.209,274.596 230.209,274.263 231.5,274.5C 231.5,296.5 231.5,318.5 231.5,340.5C 221.5,340.5 211.5,340.5 201.5,340.5C 201.5,342.167 201.5,343.833 201.5,345.5C 200.539,343.735 200.205,341.735 200.5,339.5C 210.5,339.5 220.5,339.5 230.5,339.5C 231.156,317.807 230.489,296.474 228.5,275.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0e619f",
    d: "M 231.5,274.5 C 249.804,277.659 268.137,280.659 286.5,283.5C 286.5,302.5 286.5,321.5 286.5,340.5C 294.167,340.5 301.833,340.5 309.5,340.5C 309.5,342.167 309.5,343.833 309.5,345.5C 273.5,345.5 237.5,345.5 201.5,345.5C 201.5,343.833 201.5,342.167 201.5,340.5C 211.5,340.5 221.5,340.5 231.5,340.5C 231.5,318.5 231.5,296.5 231.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3372a9",
    d: "M 62.5,276.5 C 65.8606,277.203 66.1939,278.537 63.5,280.5C 62.5713,279.311 62.238,277.978 62.5,276.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e68a3",
    d: "M 434.5,276.5 C 436.048,276.821 436.715,277.821 436.5,279.5C 433.752,279.598 433.086,278.598 434.5,276.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#338fdd",
    d: "M 223.5,276.5 C 225.167,276.5 226.833,276.5 228.5,276.5C 228.5,279.5 228.5,282.5 228.5,285.5C 222.868,287.003 217.368,286.67 212,284.5C 211.289,282.633 211.789,281.133 213.5,280C 216.85,278.514 220.184,277.347 223.5,276.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a92bc",
    d: "M 286.5,283.5 C 286.833,283.5 287.167,283.5 287.5,283.5C 287.5,302.167 287.5,320.833 287.5,339.5C 295.019,339.175 302.352,339.508 309.5,340.5C 301.833,340.5 294.167,340.5 286.5,340.5C 286.5,321.5 286.5,302.5 286.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#296ca6",
    d: "M 432.5,283.5 C 433.5,283.5 434.5,283.5 435.5,283.5C 435.5,284.5 435.5,285.5 435.5,286.5C 434.5,286.5 433.5,286.5 432.5,286.5C 432.5,285.5 432.5,284.5 432.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3874ab",
    d: "M 63.5,283.5 C 64.5,283.5 65.5,283.5 66.5,283.5C 65.5,288.833 64.5,288.833 63.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#447eb1",
    d: "M 65.5,290.5 C 68.8606,291.203 69.1939,292.537 66.5,294.5C 64.3576,293.563 64.0243,292.23 65.5,290.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#457db0",
    d: "M 431.5,290.5 C 434.861,291.203 435.194,292.537 432.5,294.5C 430.358,293.563 430.024,292.23 431.5,290.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#286ba5",
    d: "M 429.5,297.5 C 430.5,297.5 431.5,297.5 432.5,297.5C 432.5,298.5 432.5,299.5 432.5,300.5C 431.5,300.5 430.5,300.5 429.5,300.5C 429.5,299.5 429.5,298.5 429.5,297.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3473aa",
    d: "M 67.5,297.5 C 68.5862,297.62 69.2528,298.287 69.5,299.5C 68.6964,301.957 67.6964,301.957 66.5,299.5C 66.8627,298.817 67.1961,298.15 67.5,297.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#246aa4",
    d: "M 427.5,304.5 C 428.5,304.5 429.5,304.5 430.5,304.5C 430.5,305.5 430.5,306.5 430.5,307.5C 429.5,307.5 428.5,307.5 427.5,307.5C 427.5,306.5 427.5,305.5 427.5,304.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#226ba5",
    d: "M 69.5,304.5 C 71.9701,305.36 72.1368,306.694 70,308.5C 68.2317,307.318 68.0651,305.985 69.5,304.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c76ac",
    d: "M 71.5,311.5 C 72.9953,311.415 73.9953,312.081 74.5,313.5C 73.1667,314.833 71.8333,314.833 70.5,313.5C 70.8627,312.817 71.1961,312.15 71.5,311.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f78ad",
    d: "M 424.5,311.5 C 425.833,311.5 427.167,311.5 428.5,311.5C 428.5,312.5 428.5,313.5 428.5,314.5C 427.167,314.5 425.833,314.5 424.5,314.5C 424.5,313.5 424.5,312.5 424.5,311.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#276ba5",
    d: "M 73.5,318.5 C 74.5,318.5 75.5,318.5 76.5,318.5C 76.5,319.5 76.5,320.5 76.5,321.5C 75.5,321.5 74.5,321.5 73.5,321.5C 73.5,320.5 73.5,319.5 73.5,318.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#256aa5",
    d: "M 422.5,318.5 C 423.5,318.5 424.5,318.5 425.5,318.5C 425.5,319.5 425.5,320.5 425.5,321.5C 424.5,321.5 423.5,321.5 422.5,321.5C 422.5,320.5 422.5,319.5 422.5,318.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2a8cdc",
    d: "M 127.5,323.5 C 130.777,325.787 133.444,328.787 135.5,332.5C 133.418,336.747 130.751,340.581 127.5,344C 131.952,342.783 136.286,340.95 140.5,338.5C 143.006,341.174 145.339,344.008 147.5,347C 141.377,352.615 135.043,358.115 128.5,363.5C 126.11,362.109 124.443,360.109 123.5,357.5C 126.607,354.44 129.941,351.606 133.5,349C 128.833,350.333 124.167,351.667 119.5,353C 118.101,351.938 117.101,350.605 116.5,349C 119.119,345.244 121.286,341.411 123,337.5C 119.687,339.979 116.52,342.645 113.5,345.5C 111.844,343.54 110.177,341.54 108.5,339.5C 115.09,334.386 121.423,329.053 127.5,323.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3873aa",
    d: "M 77.5,324.5 C 79.1042,325.287 79.7709,326.62 79.5,328.5C 78.5,328.5 77.5,328.5 76.5,328.5C 76.4326,327.041 76.7659,325.708 77.5,324.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#447aaf",
    d: "M 420.5,324.5 C 422.176,325.183 422.843,326.517 422.5,328.5C 421.5,328.5 420.5,328.5 419.5,328.5C 419.433,327.041 419.766,325.708 420.5,324.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#298cdc",
    d: "M 364.5,326.5 C 373.506,325.025 378.006,328.692 378,337.5C 376.167,340 374.333,342.5 372.5,345C 374.976,346.309 376.976,348.142 378.5,350.5C 377.577,352.924 376.077,354.924 374,356.5C 366.898,351.698 360.064,346.531 353.5,341C 357.054,336.047 360.721,331.214 364.5,326.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#236ba5",
    d: "M 79.5,331.5 C 80.5,331.5 81.5,331.5 82.5,331.5C 82.5,332.5 82.5,333.5 82.5,334.5C 81.5,334.5 80.5,334.5 79.5,334.5C 79.5,333.5 79.5,332.5 79.5,331.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e69a3",
    d: "M 416.5,331.5 C 417.5,331.5 418.5,331.5 419.5,331.5C 419.5,332.5 419.5,333.5 419.5,334.5C 418.5,334.5 417.5,334.5 416.5,334.5C 416.5,333.5 416.5,332.5 416.5,331.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eff6fc",
    d: "M 365.5,334.5 C 370.587,334.284 371.587,336.118 368.5,340C 366.339,340.722 364.672,340.055 363.5,338C 364.823,337.184 365.489,336.017 365.5,334.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#407baf",
    d: "M 83.5,337.5 C 86.8606,338.203 87.1939,339.537 84.5,341.5C 82.3576,340.563 82.0243,339.23 83.5,337.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f7aae",
    d: "M 413.5,337.5 C 416.861,338.203 417.194,339.537 414.5,341.5C 412.358,340.563 412.024,339.23 413.5,337.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3874ab",
    d: "M 86.5,343.5 C 88.9118,343.694 89.9118,345.027 89.5,347.5C 88.5,347.5 87.5,347.5 86.5,347.5C 86.5,346.167 86.5,344.833 86.5,343.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c76ac",
    d: "M 410.5,343.5 C 412.176,344.183 412.843,345.517 412.5,347.5C 411.5,347.5 410.5,347.5 409.5,347.5C 409.433,346.041 409.766,344.708 410.5,343.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#298cdc",
    d: "M 347.5,346.5 C 354.076,351.57 360.243,357.237 366,363.5C 366.617,364.449 366.451,365.282 365.5,366C 363.631,367.602 361.631,368.602 359.5,369C 354,363.5 348.5,358 343,352.5C 344.138,350.487 345.638,348.487 347.5,346.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f68a3",
    d: "M 90.5,350.5 C 93.9571,350.667 94.2904,351.667 91.5,353.5C 90.6143,352.675 90.281,351.675 90.5,350.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#296ca6",
    d: "M 405.5,350.5 C 406.5,350.5 407.5,350.5 408.5,350.5C 408.5,351.5 408.5,352.5 408.5,353.5C 407.5,353.5 406.5,353.5 405.5,353.5C 405.5,352.5 405.5,351.5 405.5,350.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#298cdc",
    d: "M 151.5,351.5 C 157.977,355.252 163.977,359.752 169.5,365C 168.695,366.972 167.361,368.472 165.5,369.5C 162.5,367 159.5,364.5 156.5,362C 155.552,361.517 154.552,361.351 153.5,361.5C 153.351,362.552 153.517,363.552 154,364.5C 156.446,366.959 158.946,369.292 161.5,371.5C 160.5,372.833 159.5,374.167 158.5,375.5C 155.193,373.36 152.026,371.026 149,368.5C 147.024,369.543 146.524,370.877 147.5,372.5C 150.833,375.167 154.167,377.833 157.5,380.5C 156.167,382.167 154.833,383.833 153.5,385.5C 147.666,380.83 141.999,375.997 136.5,371C 141.625,364.578 146.625,358.078 151.5,351.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#306fa8",
    d: "M 94.5,356.5 C 95.5,356.5 96.5,356.5 97.5,356.5C 97.5,357.5 97.5,358.5 97.5,359.5C 96.5,359.5 95.5,359.5 94.5,359.5C 94.5,358.5 94.5,357.5 94.5,356.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2d6ea7",
    d: "M 401.5,356.5 C 402.5,356.5 403.5,356.5 404.5,356.5C 404.5,357.5 404.5,358.5 404.5,359.5C 403.5,359.5 402.5,359.5 401.5,359.5C 401.5,358.5 401.5,357.5 401.5,356.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#288cdc",
    d: "M 336.5,356.5 C 338.193,357.475 339.693,358.808 341,360.5C 344.638,366.303 348.471,371.97 352.5,377.5C 350.424,379.288 348.257,380.954 346,382.5C 344,379.833 342,377.167 340,374.5C 337.411,376.211 334.911,378.045 332.5,380C 334.363,382.364 336.029,384.864 337.5,387.5C 335.5,389.327 333.333,390.994 331,392.5C 326.043,385.42 321.21,378.253 316.5,371C 318.667,369.5 320.833,368 323,366.5C 324.771,369.052 326.771,371.385 329,373.5C 331.639,372.432 333.805,370.766 335.5,368.5C 334.167,366.167 332.833,363.833 331.5,361.5C 333.006,359.599 334.673,357.932 336.5,356.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3874ab",
    d: "M 98.5,361.5 C 101.275,361.834 101.941,363.167 100.5,365.5C 98.8888,364.68 98.2222,363.346 98.5,361.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3974ab",
    d: "M 398.5,361.5 C 401.041,362.623 401.041,363.956 398.5,365.5C 397.374,364.192 397.374,362.858 398.5,361.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b75ac",
    d: "M 103.5,367.5 C 104.995,367.415 105.995,368.081 106.5,369.5C 105.167,370.833 103.833,370.833 102.5,369.5C 102.863,368.817 103.196,368.15 103.5,367.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b75ab",
    d: "M 393.5,367.5 C 394.995,367.415 395.995,368.081 396.5,369.5C 395.167,370.833 393.833,370.833 392.5,369.5C 392.863,368.817 393.196,368.15 393.5,367.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#288bdc",
    d: "M 172.5,367.5 C 176.176,368.754 179.676,370.421 183,372.5C 182.538,377.148 182.205,381.814 182,386.5C 184.647,382.686 187.813,379.353 191.5,376.5C 194.863,377.843 197.863,379.676 200.5,382C 196.954,389.592 193.287,397.092 189.5,404.5C 187.004,403.42 184.67,402.086 182.5,400.5C 192.441,383.196 191.441,382.363 179.5,398C 176.377,398.439 174.044,397.272 172.5,394.5C 173.889,389.531 174.722,384.531 175,379.5C 173.769,384.97 171.269,389.636 167.5,393.5C 163.998,393.381 162.498,391.715 163,388.5C 166.269,381.518 169.436,374.518 172.5,367.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b6ea7",
    d: "M 108.5,372.5 C 110.476,373.427 110.809,374.76 109.5,376.5C 107.358,375.563 107.024,374.23 108.5,372.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e6fa8",
    d: "M 388.5,372.5 C 391.861,373.203 392.194,374.537 389.5,376.5C 388.571,375.311 388.238,373.978 388.5,372.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2d8ddc",
    d: "M 303.5,375.5 C 308.06,374.658 311.727,375.991 314.5,379.5C 312.755,381.459 310.589,382.792 308,383.5C 305.426,380.741 303.26,381.074 301.5,384.5C 306.111,384.848 310.778,385.015 315.5,385C 320.824,389.954 320.824,394.954 315.5,400C 310.804,402.68 305.804,403.68 300.5,403C 296.085,398.91 296.918,396.41 303,395.5C 305.12,396.459 307.287,396.626 309.5,396C 310.973,395.29 311.64,394.124 311.5,392.5C 306.519,393.332 301.519,393.498 296.5,393C 293.208,390.588 292.041,387.421 293,383.5C 295.94,379.963 299.44,377.297 303.5,375.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2068a3",
    d: "M 112.5,378.5 C 113.5,378.5 114.5,378.5 115.5,378.5C 115.5,379.5 115.5,380.5 115.5,381.5C 114.5,381.5 113.5,381.5 112.5,381.5C 112.5,380.5 112.5,379.5 112.5,378.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b67a2",
    d: "M 383.5,378.5 C 384.5,378.5 385.5,378.5 386.5,378.5C 386.5,379.5 386.5,380.5 386.5,381.5C 385.5,381.5 384.5,381.5 383.5,381.5C 383.5,380.5 383.5,379.5 383.5,378.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b8cdc",
    d: "M 205.5,382.5 C 211.556,383.351 217.556,384.518 223.5,386C 230.059,390.245 230.059,394.578 223.5,399C 227.521,403.265 227.188,407.265 222.5,411C 215.089,411.019 207.755,410.186 200.5,408.5C 202.167,399.833 203.833,391.167 205.5,382.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#226aa4",
    d: "M 117.5,383.5 C 118.5,383.5 119.5,383.5 120.5,383.5C 120.5,384.5 120.5,385.5 120.5,386.5C 119.5,386.5 118.5,386.5 117.5,386.5C 117.5,385.5 117.5,384.5 117.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#266ba5",
    d: "M 378.5,383.5 C 379.5,383.5 380.5,383.5 381.5,383.5C 381.5,384.5 381.5,385.5 381.5,386.5C 380.5,386.5 379.5,386.5 378.5,386.5C 378.5,385.5 378.5,384.5 378.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2c8cdc",
    d: "M 276.5,384.5 C 287.539,384.925 290.539,389.925 285.5,399.5C 287.306,402.472 289.306,405.305 291.5,408C 289.084,409.063 286.584,409.896 284,410.5C 281.532,408.358 279.365,405.858 277.5,403C 276.552,402.517 275.552,402.351 274.5,402.5C 274.46,405.881 274.793,409.214 275.5,412.5C 272.751,412.274 270.084,412.607 267.5,413.5C 265.575,404.876 263.908,396.209 262.5,387.5C 267.404,387.046 272.07,386.046 276.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7cbaea",
    d: "M 257.5,388.5 C 250.167,388.5 242.833,388.5 235.5,388.5C 235.813,392.042 235.479,395.375 234.5,398.5C 234.5,394.833 234.5,391.167 234.5,387.5C 242.352,387.175 250.018,387.508 257.5,388.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3975ab",
    d: "M 122.5,388.5 C 123.978,388.238 125.311,388.571 126.5,389.5C 125.68,391.111 124.346,391.778 122.5,391.5C 122.5,390.5 122.5,389.5 122.5,388.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2d8ddc",
    d: "M 257.5,388.5 C 257.5,390.5 257.5,392.5 257.5,394.5C 252.833,394.5 248.167,394.5 243.5,394.5C 243.5,395.5 243.5,396.5 243.5,397.5C 246.962,398.482 250.629,398.815 254.5,398.5C 254.5,400.167 254.5,401.833 254.5,403.5C 250.5,403.5 246.5,403.5 242.5,403.5C 242.232,405.099 242.566,406.432 243.5,407.5C 248.167,407.5 252.833,407.5 257.5,407.5C 257.5,409.833 257.5,412.167 257.5,414.5C 249.833,414.5 242.167,414.5 234.5,414.5C 234.5,409.167 234.5,403.833 234.5,398.5C 235.479,395.375 235.813,392.042 235.5,388.5C 242.833,388.5 250.167,388.5 257.5,388.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b76ac",
    d: "M 372.5,388.5 C 373.833,388.5 375.167,388.5 376.5,388.5C 376.5,389.5 376.5,390.5 376.5,391.5C 374.027,391.912 372.694,390.912 372.5,388.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f9fd",
    d: "M 212.5,389.5 C 214.482,389.995 216.482,390.495 218.5,391C 219.337,392.011 219.67,393.178 219.5,394.5C 217.167,394.5 214.833,394.5 212.5,394.5C 212.5,392.833 212.5,391.167 212.5,389.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f8fd",
    d: "M 273.5,391.5 C 275.5,391.5 277.5,391.5 279.5,391.5C 279.714,393.144 279.38,394.644 278.5,396C 276.527,396.495 274.527,396.662 272.5,396.5C 272.366,394.708 272.699,393.042 273.5,391.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3271a9",
    d: "M 129.5,392.5 C 131.104,393.287 131.771,394.62 131.5,396.5C 130.5,396.5 129.5,396.5 128.5,396.5C 128.433,395.041 128.766,393.708 129.5,392.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3271a9",
    d: "M 368.5,392.5 C 370.104,393.287 370.771,394.62 370.5,396.5C 369.5,396.5 368.5,396.5 367.5,396.5C 367.433,395.041 367.766,393.708 368.5,392.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f77ad",
    d: "M 134.5,397.5 C 135.5,397.5 136.5,397.5 137.5,397.5C 137.5,398.5 137.5,399.5 137.5,400.5C 134.433,400.879 133.433,399.879 134.5,397.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6ab0e7",
    d: "M 243.5,397.5 C 247.5,397.5 251.5,397.5 255.5,397.5C 255.5,399.5 255.5,401.5 255.5,403.5C 255.167,403.5 254.833,403.5 254.5,403.5C 254.5,401.833 254.5,400.167 254.5,398.5C 250.629,398.815 246.962,398.482 243.5,397.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b6ca6",
    d: "M 361.5,397.5 C 362.5,397.5 363.5,397.5 364.5,397.5C 364.5,398.5 364.5,399.5 364.5,400.5C 363.5,400.5 362.5,400.5 361.5,400.5C 361.5,399.5 361.5,398.5 361.5,397.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8fbfd",
    d: "M 210.5,399.5 C 213.605,399.599 216.272,400.599 218.5,402.5C 216.956,404.446 214.956,404.946 212.5,404C 210.893,402.951 210.227,401.451 210.5,399.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#226aa4",
    d: "M 140.5,401.5 C 142.048,401.821 142.715,402.821 142.5,404.5C 139.752,404.598 139.086,403.598 140.5,401.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b77ac",
    d: "M 356.5,401.5 C 357.995,401.415 358.995,402.081 359.5,403.5C 358.167,404.833 356.833,404.833 355.5,403.5C 355.863,402.817 356.196,402.15 356.5,401.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a9d2f1",
    d: "M 254.5,403.5 C 254.833,403.5 255.167,403.5 255.5,403.5C 251.702,404.483 247.702,404.817 243.5,404.5C 243.5,405.5 243.5,406.5 243.5,407.5C 242.566,406.432 242.232,405.099 242.5,403.5C 246.5,403.5 250.5,403.5 254.5,403.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#216aa4",
    d: "M 146.5,405.5 C 148.048,405.821 148.715,406.821 148.5,408.5C 145.752,408.598 145.086,407.598 146.5,405.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c77ad",
    d: "M 350.5,405.5 C 351.995,405.415 352.995,406.081 353.5,407.5C 352.167,408.833 350.833,408.833 349.5,407.5C 349.863,406.817 350.196,406.15 350.5,405.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c76ac",
    d: "M 152.5,409.5 C 153.995,409.415 154.995,410.081 155.5,411.5C 154.167,412.833 152.833,412.833 151.5,411.5C 151.863,410.817 152.196,410.15 152.5,409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c76ac",
    d: "M 344.5,409.5 C 345.995,409.415 346.995,410.081 347.5,411.5C 346.167,412.833 344.833,412.833 343.5,411.5C 343.863,410.817 344.196,410.15 344.5,409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1966a2",
    d: "M 158.5,413.5 C 161.957,413.667 162.29,414.667 159.5,416.5C 158.614,415.675 158.281,414.675 158.5,413.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#427baf",
    d: "M 338.5,412.5 C 341.861,413.203 342.194,414.537 339.5,416.5C 337.358,415.563 337.024,414.23 338.5,412.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#226ba5",
    d: "M 164.5,416.5 C 165.5,416.5 166.5,416.5 167.5,416.5C 167.5,417.5 167.5,418.5 167.5,419.5C 166.5,419.5 165.5,419.5 164.5,419.5C 164.5,418.5 164.5,417.5 164.5,416.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f69a4",
    d: "M 331.5,416.5 C 332.5,416.5 333.5,416.5 334.5,416.5C 334.5,417.5 334.5,418.5 334.5,419.5C 333.5,419.5 332.5,419.5 331.5,419.5C 331.5,418.5 331.5,417.5 331.5,416.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#276ba5",
    d: "M 171.5,419.5 C 175.31,420.754 175.31,421.754 171.5,422.5C 171.5,421.5 171.5,420.5 171.5,419.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2169a3",
    d: "M 325.5,419.5 C 328.674,419.952 329.007,420.952 326.5,422.5C 324.481,421.867 324.147,420.867 325.5,419.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2a6da6",
    d: "M 177.5,422.5 C 178.5,422.5 179.5,422.5 180.5,422.5C 180.5,423.5 180.5,424.5 180.5,425.5C 179.5,425.5 178.5,425.5 177.5,425.5C 177.5,424.5 177.5,423.5 177.5,422.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#266ca6",
    d: "M 318.5,422.5 C 319.5,422.5 320.5,422.5 321.5,422.5C 321.5,423.5 321.5,424.5 321.5,425.5C 320.5,425.5 319.5,425.5 318.5,425.5C 318.5,424.5 318.5,423.5 318.5,422.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c76ac",
    d: "M 184.5,424.5 C 185.5,424.5 186.5,424.5 187.5,424.5C 187.778,426.346 187.111,427.68 185.5,428.5C 184.571,427.311 184.238,425.978 184.5,424.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#306fa7",
    d: "M 311.5,424.5 C 312.5,424.5 313.5,424.5 314.5,424.5C 314.5,425.5 314.5,426.5 314.5,427.5C 313.5,427.5 312.5,427.5 311.5,427.5C 311.5,426.5 311.5,425.5 311.5,424.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#266ba5",
    d: "M 191.5,427.5 C 192.5,427.5 193.5,427.5 194.5,427.5C 194.5,428.5 194.5,429.5 194.5,430.5C 193.5,430.5 192.5,430.5 191.5,430.5C 191.5,429.5 191.5,428.5 191.5,427.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1765a1",
    d: "M 304.5,427.5 C 305.5,427.5 306.5,427.5 307.5,427.5C 306.754,431.31 305.754,431.31 304.5,427.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#296ca6",
    d: "M 198.5,429.5 C 199.5,429.5 200.5,429.5 201.5,429.5C 201.5,430.5 201.5,431.5 201.5,432.5C 200.5,432.5 199.5,432.5 198.5,432.5C 198.5,431.5 198.5,430.5 198.5,429.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3372a9",
    d: "M 297.5,429.5 C 298.978,429.238 300.311,429.571 301.5,430.5C 299.537,433.194 298.203,432.861 297.5,429.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e70a8",
    d: "M 205.5,430.5 C 208.861,431.203 209.194,432.537 206.5,434.5C 205.571,433.311 205.238,431.978 205.5,430.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#417cb0",
    d: "M 291.5,430.5 C 294.861,431.203 295.194,432.537 292.5,434.5C 290.358,433.563 290.024,432.23 291.5,430.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#226aa4",
    d: "M 212.5,432.5 C 213.5,432.5 214.5,432.5 215.5,432.5C 215.5,433.5 215.5,434.5 215.5,435.5C 214.5,435.5 213.5,435.5 212.5,435.5C 212.5,434.5 212.5,433.5 212.5,432.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#256aa4",
    d: "M 283.5,432.5 C 284.5,432.5 285.5,432.5 286.5,432.5C 286.5,433.5 286.5,434.5 286.5,435.5C 285.5,435.5 284.5,435.5 283.5,435.5C 283.5,434.5 283.5,433.5 283.5,432.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2c6ea7",
    d: "M 219.5,433.5 C 220.5,433.5 221.5,433.5 222.5,433.5C 222.5,434.5 222.5,435.5 222.5,436.5C 221.5,436.5 220.5,436.5 219.5,436.5C 219.5,435.5 219.5,434.5 219.5,433.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b6da6",
    d: "M 226.5,434.5 C 227.5,434.5 228.5,434.5 229.5,434.5C 229.5,435.5 229.5,436.5 229.5,437.5C 228.5,437.5 227.5,437.5 226.5,437.5C 226.5,436.5 226.5,435.5 226.5,434.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1965a1",
    d: "M 270.5,434.5 C 272.048,434.821 272.715,435.821 272.5,437.5C 269.752,437.598 269.086,436.598 270.5,434.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e68a3",
    d: "M 277.5,433.5 C 279.048,433.821 279.715,434.821 279.5,436.5C 276.752,436.598 276.086,435.598 277.5,433.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2a6da6",
    d: "M 233.5,435.5 C 234.5,435.5 235.5,435.5 236.5,435.5C 236.5,436.5 236.5,437.5 236.5,438.5C 235.5,438.5 234.5,438.5 233.5,438.5C 233.5,437.5 233.5,436.5 233.5,435.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f69a4",
    d: "M 262.5,435.5 C 263.5,435.5 264.5,435.5 265.5,435.5C 265.5,436.5 265.5,437.5 265.5,438.5C 264.5,438.5 263.5,438.5 262.5,438.5C 262.5,437.5 262.5,436.5 262.5,435.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#447db0",
    d: "M 241.5,435.5 C 244.861,436.203 245.194,437.537 242.5,439.5C 240.358,438.563 240.024,437.23 241.5,435.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#437eb1",
    d: "M 248.5,435.5 C 251.861,436.203 252.194,437.537 249.5,439.5C 247.358,438.563 247.024,437.23 248.5,435.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3472aa",
    d: "M 255.5,435.5 C 258.861,436.203 259.194,437.537 256.5,439.5C 255.571,438.311 255.238,436.978 255.5,435.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Year);
export default __webpack_public_path__ + "static/media/1 Year.3933e09f9d5d8cc0fc8b5f4107390fb5.svg";
export { ForwardRef as ReactComponent };